exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".downloading-agent{margin-top:20px}.downloading-agent .downloading-agent-message .message-icon{text-align:center}.downloading-agent .downloading-agent-message .message-title{font-size:18px;font-weight:700;text-align:center}.downloading-agent .downloading-agent-message .message-icon,.downloading-agent .downloading-agent-message .message-title{margin-bottom:15px}.downloading-agent .looking-for-agent-container{text-align:center}.downloading-agent .installed-agent-selector{text-align:center;background-color:#fbfbfb;box-shadow:2.5px 2.5px 0 #e5e5e5;padding:10px}.downloading-agent .installed-agent-selector:not(:first-of-type){margin-top:10px}.downloading-agent .installed-agent-selector .icon-holder{margin-bottom:5px}.downloading-agent .installed-agent-selector .icon-holder img{width:36px;height:36px}.downloading-agent .button-holder{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/common/AgentSelection/agentForm.scss
// module id = 1006
// module chunks = 0